import React from 'react';
import './index.css';
import Background from './background';
import Player from './player';
import Obstacle from './obstacleTranslate3d';
import Text from './text';
import Tutorial from './tutorial';
import Score from './score';
import HighScore from './highScore';
import GameOver from './gameOver';


export default class GameWindow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      playing:false,
      moving:false,
      playerY:0,
      objX:850,
      speed:4.5,
      text:'',
      jumpCount:0,
      score:0
    }
    this.getObstacleX = this.getObstacleX.bind(this)
    this.getSpeed = this.getSpeed.bind(this)
    this.getPlayerY = this.getPlayerY.bind(this)
    this.getText = this.getText.bind(this)
    this.checkPlaying = this.checkPlaying.bind(this)
    this.getMoving = this.getMoving.bind(this)
    this.increaseJumpCount = this.increaseJumpCount.bind(this)
    this.getScore = this.getScore.bind(this)
    this.restart = this.restart.bind(this)
  }

  checkPlaying(x) {
    //if (x > -30 && x < 120) { //20 margin to edge, obj 50 wide, ****need to adjust when sprite is correct***
    
      if (this.state.playerY < 65 ) {
        //console.log('x = ' + x)
        //console.log('y = ' + this.state.playerY)
        this.setState({playing:false})
      }
    //}
  }

  getMoving() {
    this.setState({moving:!this.state.moving})
  }

  getObstacleX (x) {
    this.setState({objX:x})
    this.checkPlaying(x)
  }

  getSpeed (speed) {
    this.setState({speed:speed})
  }

  getPlayerY (y) {
    this.setState({playerY:y})
  }

  getText (text) {
    this.setState({text:text})
  }

  increaseJumpCount () {
    this.setState({jumpCount: this.state.jumpCount + 1})
  }

  getScore(score) {
    this.setState({score:score})
  }

  restart() {
    //this.setState({playing:true})
      this.setState({      
        playing:true,
        playerY:0,
        objX:850,
        text:'',
        jumpCount:0,
        score:0
      })    
  }

  componentDidMount(){
    if (this.props.showMenu === false) {
      this.setState({playing:true})
    }
  }

  render() {
    return (
      <div id="gameWindow">
                <Background playing={this.state.playing} moving={this.state.moving}/>
                <Player playing={this.state.playing} getPlayerY={this.getPlayerY} text={this.state.text} jumpCount={this.state.jumpCount} increaseJumpCount={this.increaseJumpCount} getMoving={this.getMoving} moving={this.state.moving} speakerOn={this.props.speakerOn} speed={this.state.speed}/>
                <Obstacle playing={this.state.playing} getObstacleX={this.getObstacleX} getSpeed={this.getSpeed} getText={this.getText} difficulty={this.props.difficulty} jumpCount={this.state.jumpCount}/>
                <Text text={this.state.text} jumpCount={this.state.jumpCount}/>
                {this.state.jumpCount === 0 && <Tutorial difficulty={this.props.difficulty}/> }
                <Score playing={this.state.playing} jumpCount={this.state.jumpCount} getScore={this.getScore}/>
                <HighScore playing={this.state.playing} score={this.state.score} difficulty={this.props.difficulty}/> 
                {!this.state.playing && <GameOver backToMenu={this.props.backToMenu} restart={this.restart}/> }
      </div>
    )
  }
}



